<template>
  <div>
    <section class="row">
      <div class="col-xs-12 text-center">
        <form class="form-inline" id="product-search" @submit.stop.prevent>
          <div class="form-group form-group-lg">
            <div class="input-group">
              <input
                class="form-control"
                v-model="query"
                debounce="450"
                placeholder="Search..."
                type="search"
              />
              <div class="input-group-addon" @click="reset()">
                <i class="fa fa-refresh"></i>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>

    <section class="row">
      <div class="col-xs-12">
        <table class="table table-striped" v-if="products.length">
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th class="text-center" v-if="managing">Out of Stock</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in products"
              is="product"
              :product="product"
              track-by="id"
            ></tr>
          </tbody>
        </table>

        <div
          class="alert alert-info text-center"
          role="alert"
          v-if="!products.length && query.trim() != ''"
        >
          <strong>Oops!</strong> No products match the
          <b>&ldquo;{{ query }}&rdquo;</b> search query.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ProductFinder from 'src/product_finder';
import Product from '../ProductWithStock';
import InteractsWithState from 'mixins/InteractsWithState';

export default {
  mixins: [InteractsWithState],
  props: [
    {
      name: 'managing',
      type: Boolean,
      default: true,
    },
    {
      name: 'finder',
      type: Object,
      default: () => new ProductFinder(),
    },
  ],

  data() {
    return {
      query: '',
    };
  },

  watch: {
    query(v) {
      this.finder.search(v);
    },
  },

  attached() {
    this.reset();
  },

  detached() {
    this.finder.flushResults();
  },

  computed: {
    products() {
      return this.state.products;
    },
  },

  methods: {
    reset() {
      this.query = '';
      this.finder.flushResults().reset().search();
    },
  },

  components: { Product },
};
</script>



// WEBPACK FOOTER //
// Products.vue?c023b972